import moment from 'moment';
import DatePicker from "vue2-datepicker";
import StaffProbationHdrService from "@/service/StaffProbationHdrService";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { Staff } from "@/model/Staff";
import { StaffProbationDtl } from "@/model/StaffProbationDtl";
import { StaffProbationHdr } from "@/model/StaffProbationHdr";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import employeeProbationValidationObj from "./S070200-EmployeeProbationValidation.js";
import Settings from '../../../constants/Settings.js';
var employeeProbationValidation = new employeeProbationValidationObj();
export default {
  name: "employeeProbation",
  mounted() {
    employeeProbationValidation.employeeProbationValidation();
    this.getAllAssessTemp();
    this.getPorbResultType();
  },
  components: {
    DatePicker
  },
  data: () => ({
    dictEnum: dictEnum,
    staff: new Staff(),
    staffProbationHdr: new StaffProbationHdr(),
    staffProbationDtl: new StaffProbationDtl(),
    tempStaffProbationHdr: new StaffProbationHdr(),
    groupList: [],
    assessTempList: [],
    activeTab: 'Interview',
    isViewMode: true,
    isEditMode: false,
    selectedCompany: "",
    staffProbationList: [],
    porbResultTypeList: [],
    selectedAssessTemp: {
      Grp: "",
      Item: "",
      OptRadioList: []
    },
  }),
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
  },
  methods: {
    onTabChange: function (data) {
      var self = this;
      self.selectedAssessTemp = data;
      self.activeTab = data.EDesc;
    },
    resetStaffProbation: function () {
      var self = this;
      self.isViewMode = true;
      self.isEditMode = false;
      self.tempStaffProbationHdr = new StaffProbationHdr();
      self.staffProbationHdr = new StaffProbationHdr();
      self.$validator.reset();
      self.vErrors.clear();
    },
    onAddButtonClick: function () {
      var self = this;
      self.isViewMode = false;
      self.isEditMode = false;
      self.tempStaffProbationHdr = new StaffProbationHdr();
      self.staffProbationHdr = new StaffProbationHdr();
      self.getAllAssessTemp();
    },
    selectStaffProbation: function (item) {
      var self = this;
      self.tempStaffProbationHdr = item;
    },
    changeStatus: function () {
      var self = this;
      if (self.staffProbationHdr.PorbResult != "X") {
        self.staffProbationHdr.DateEff = moment().format(Settings.DateTime.yyyymmdd);
        self.staffProbationHdr.MonthExtend = "";
      }
      else {
        self.staffProbationHdr.DateEff = "";
      }
    },
    async onViewButtonClick(item) {
      var self = this;
      self.isViewMode = false;
      self.isEditMode = true;
      var obj = {
        staffId: self.staff.StaffID,
        dateInt: moment(item.DateInt).format(Settings.DateTime.yyyymmdd)
      };
      const response = await StaffProbationHdrService.getStaffProbationDetail(obj);
      if (response.data.IsSuccess) {
        self.staffProbationHdr = response.data.Data;
        self.staffProbationHdr.DateInt = moment(self.staffProbationHdr.DateInt).format(Settings.DateTime.yyyymmdd);
        if (self.staffProbationHdr.DateEff != null && self.staffProbationHdr.DateEff != "" && self.staffProbationHdr.DateEff == '1900-01-01') {
          self.staffProbationHdr.DateEff = moment().format(Settings.DateTime.yyyymmdd);
        }
        else {
          self.staffProbationHdr.DateEff = moment(self.staffProbationHdr.DateEff).format(Settings.DateTime.yyyymmdd);
        }
        self.staffProbationHdr.DateAdd = moment(self.staffProbationHdr.DateAdd).format(Settings.DateTime.yyyymmdd);
        var monthExtendDate = moment(self.staffProbationHdr.DateInt).add(self.staffProbationHdr.MonthExtend, "months").format(Settings.DateTime.yyyymmdd);
        self.staffProbationHdr.MonthExtendDate = monthExtendDate;
        await self.getAllAssessTemp();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllAssessTemp() {
      var self = this;
      const obj = {};
      const response = await StaffProbationHdrService.getAllPorbAssessTemp(obj);
      if (response.data.IsSuccess) {
        if (response.data.Data != null && response.data.Data.length > 0) {
          var groupList = response.data.Data.filter(
            obj => obj.Item == 0
          );
          self.groupList = groupList;
          self.activeTab = self.groupList[0].EDesc;
          self.selectedAssessTemp = self.groupList[0];
          var assessTempList = response.data.Data.filter(
            obj => obj.Item !== 0
          );
          if (self.staffProbationHdr.StaffProbationDtlList != null && self.staffProbationHdr.StaffProbationDtlList.length > 0 && assessTempList != null && assessTempList.length > 0) {
            assessTempList.forEach((element) => {
              var staffProbationDtlDetail = self.staffProbationHdr.StaffProbationDtlList.find((obj) => obj.Grp == element.Grp && obj.Item == element.Item);
              if (staffProbationDtlDetail != null && staffProbationDtlDetail != undefined) {
                element.Ans = staffProbationDtlDetail.Ans;
                element.Rem = staffProbationDtlDetail.Rem;
              }
            }
            );
          }
          self.assessTempList = assessTempList;
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllStaffProbationList() {
      var self = this;
      const obj = {
        staffId: self.staff.StaffID
      };
      const response = await StaffProbationHdrService.getAllStaffProbationList(obj);
      if (response.data.IsSuccess) {
        self.staffProbationList = response.data.Data;
        if (self.staffProbationList != null && self.staffProbationList.length > 0) {
          self.staffProbationList.forEach(
            (element) => {
              if (element.DateInt != null && element.DateInt != "") {
                element.DateInt = moment(String(element.DateInt)).format(Settings.DateTime.yyyymmdd);
              }
              if (element.DateEff != null && element.DateEff != "" && element.DateEff != '1900-01-01') {
                element.DateEff = moment(String(element.DateEff)).format(Settings.DateTime.yyyymmdd);
              }
              else {
                element.DateEff = "1900-01-01";
              }
              if (element.DateAdd != null && element.DateAdd != "") {
                element.DateAdd = moment(String(element.DateAdd)).format(Settings.DateTime.yyyymmdd);
              }
              var monthExtendDate = moment(element.DateAdd).add(element.MonthExtend, "months").format(Settings.DateTime.yyyymmdd);
              element.MonthExtendDate = monthExtendDate;
            }
          );
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getPorbResultType() {
      var self = this;
      const obj = {};
      const response = await StaffProbationHdrService.getPorbResultType(obj);
      if (response.data.IsSuccess) {
        self.porbResultTypeList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async saveProbation() {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          self.staffProbationHdr.StaffProbationDtlList = [];
          self.assessTempList.forEach((value) => {
            if (value.AnsType == 'RAD') {
              if (value.Ans != '') {
                self.staffProbationDtl = new StaffProbationDtl();
                self.staffProbationDtl.StaffID = self.staff.StaffID;
                self.staffProbationDtl.DateInt = moment(self.staffProbationHdr.DateInt).format(Settings.DateTime.yyyymmdd);
                self.staffProbationDtl.Grp = value.Grp;
                self.staffProbationDtl.Item = value.Item;
                self.staffProbationDtl.Ans = value.Ans;
                self.staffProbationHdr.StaffProbationDtlList.push(self.staffProbationDtl);
              }
            }
          });
          if (self.staffProbationHdr.StaffProbationDtlList.length > 0) {
            self.staffProbationHdr.StaffID = self.staff.StaffID;
            self.staffProbationHdr.DateInt = moment(self.staffProbationHdr.DateInt).format(Settings.DateTime.yyyymmdd);
            if (self.staffProbationHdr.DateEff != null && self.staffProbationHdr.DateEff != "" && self.staffProbationHdr.DateEff != undefined) {
              self.staffProbationHdr.DateEff = moment(String(self.staffProbationHdr.DateEff)).format(Settings.DateTime.yyyymmdd);
            }
            else {
              self.staffProbationHdr.DateEff = "1900-01-01";
            }
            self.staffProbationHdr.MonthExtend = Number(self.staffProbationHdr.MonthExtend);
            self.staffProbationHdr.AddBy = self.$store.getters[StoreGetter.user].UserID;
            self.staffProbationHdr.ModifyBy = self.$store.getters[StoreGetter.user].UserID;
            var obj = {
              model: self.staffProbationHdr,
            }
            if (self.isEditMode) {
              self.updateStaffProbation(obj);
            }
            else {
              self.saveStaffProbation(obj);
            }
          }
          else {
            SweetAlertService.warning("Warn", self.t.t(self.dictEnum.WARN_SelectRating));
          }
        }
        else {
          SweetAlertService.warning("Warn", self.t.t(self.dictEnum.MSG_ValidationFailed));
        }
      });
    },
    async saveStaffProbation(obj) {
      var self = this;
      const response = await StaffProbationHdrService.saveStaffProbation(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetStaffProbation();
        await self.getAllStaffProbationList();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async updateStaffProbation(obj) {
      var self = this;
      const response = await StaffProbationHdrService.updateStaffProbation(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetStaffProbation();
        await self.getAllStaffProbationList();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    deleteStaffProbationPopup: function (item) {
      var self = this;
      $('#deleteStaffProbationModel').modal('show');
      self.staffProbationHdr = item;
    },
    closePopup: function (item) {
      $('#deleteStaffProbationModel').modal('hide');
    },
    changeExtension: function () {
      var self = this;
      if (Number(self.staffProbationHdr.MonthExtend) > 0 && self.staffProbationHdr.DateInt != '' && self.staffProbationHdr.DateInt != null && self.staffProbationHdr.DateInt != undefined) {
        var monthExtendDate = moment(self.staffProbationHdr.DateInt).add(self.staffProbationHdr.MonthExtend, "months").format(Settings.DateTime.yyyymmdd);
        self.staffProbationHdr.MonthExtendDate = monthExtendDate;
      }
    },
    async deleteStaffProbation() {
      var self = this;
      $('#deleteStaffProbationModel').modal('hide');
      var obj = {
        staffId: self.staff.StaffID,
        dateInt: moment(self.staffProbationHdr.DateInt).format(Settings.DateTime.yyyymmdd)
      };
      const response = await StaffProbationHdrService.deleteStaffProbation(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetStaffProbation();
        await self.getAllStaffProbationList();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeProbation/S070200-EmployeeProbation.js